/*
	Master Application Data Store. Controls Authentication and Auth Storage Across the Application
*/

const Superagent = require('superagent');
import Eventer from 'Lib/Eventer';

let AppData = Eventer.createBus('APP');

let _systemData = {
  authToken: '',
  userID: null,
  userFullName: '',
  userRoles: [],
  organizationRoles: [],
  systemTimezone: 'UTC',
  site_title: 'HSC Bos',
};

/*
	Semi-generic setter/getter functions appended to Eventer Data Store. Value Type Agnostic. Will set previously
	undefined keys on the object.
*/

AppData.set = (key, value) => {
  _systemData[key] = value;
  AppData.notifyListeners('VALUE_SET', _systemData);
};

/*
	Getter will return false if the value at that key does not exist. (No Object Dumping)
*/

AppData.get = (key) => {
  if (typeof key == 'undefined' || typeof _systemData[key] == 'undefined') {
    return false;
  } else {
    return _systemData[key];
  }
};

/*
	Uses superagent.js to login and retrieve a valid auth token from the server.
*/
AppData.loginHandler = (res) => {
  switch (res.statusCode) {
    case 200: {
      let payload = res?.body || {};
      if (payload?.status === true) {
        _systemData.authToken = payload.token;
        _systemData.userID = payload.id;
        _systemData.userFullName = payload.user_full_name;
        _systemData.userRoles = payload.user_roles;
        _systemData.organizationRoles = payload.organization_roles;
        localStorage.setItem('resource_authToken', payload.token);
        localStorage.setItem('resource_userID', payload.id);
        localStorage.setItem('resource_userFullName', payload.user_full_name);
        localStorage.setItem(
          'resource_userRoles',
          JSON.stringify(payload.user_roles),
        );
        localStorage.setItem(
          'resource_orgRoles',
          JSON.stringify(payload.organization_roles),
        );
        AppData.notifyListeners('USER_LOGGED_IN', true);
        return Promise.resolve();
      } else {
        let payload = res.body;
        AppData.notifyListeners('LOGIN_ERROR', payload);
        return Promise.reject(payload);
      }
    }
    case 401: {
      let { message, stack } = res?.error || {};
      AppData.notifyListeners('LOGIN_ERROR', {
        message,
        debug: stack,
      });
      return Promise.reject({
        message,
        debug: stack,
      });
    }
    default: {
      let payload = res?.error
        ? (({ message, stack }) => ({ message, debug: stack }))(res.error)
        : res.body;
      AppData.notifyListeners('REQUEST_SERVER_ERROR', payload);
      return Promise.reject(payload);
    }
  }
};

AppData.getUserConfig = function () {
  return Superagent.get('/auth/me')
    .then((res) => {
      let payload = res.body;
      _systemData.authToken = payload.token;
      _systemData.userID = payload.id;
      _systemData.userFullName = payload.user_full_name;
      _systemData.userRoles = payload.user_roles;
      _systemData.organizationRoles = payload.organization_roles;
      localStorage.setItem('resource_authToken', payload.token);
      localStorage.setItem('resource_userID', payload.id);
      localStorage.setItem('resource_userFullName', payload.user_full_name);
      localStorage.setItem(
        'resource_userRoles',
        JSON.stringify(payload.user_roles),
      );
      localStorage.setItem(
        'resource_orgRoles',
        JSON.stringify(payload.organization_roles),
      );
      AppData.notifyListeners('USER_LOGGED_IN', true);
      return true;
    })
    .catch((err) => {
      _systemData.authToken = '';
      _systemData.userID = null;
      _systemData.userFullName = '';
      _systemData.userRoles = [];
      _systemData.organizationRoles = [];
      clearLocalStorageAuthData();

      AppData.notifyListeners('USER_AUTH_ERR', {
        ...err.response,
        message: err.message || 'Unauthorized',
        error: err,
        text: err.response?.body?.message,
      });
      return false;
    });
};

const setAppAuthData = () => {
  AppData.set('authToken', localStorage.getItem('resource_authToken'));
  AppData.set('userID', localStorage.getItem('resource_userID'));
  AppData.set('userFullName', localStorage.getItem('resource_userFullName'));
  AppData.set(
    'userRoles',
    JSON.parse(localStorage.getItem('resource_userRoles')),
  );
  AppData.set(
    'organizationRoles',
    JSON.parse(localStorage.getItem('resource_orgRoles')),
  );
};

const clearLocalStorageAuthData = () => {
  localStorage.removeItem('resource_authToken');
  localStorage.removeItem('resource_userID');
  localStorage.removeItem('resource_username');
  localStorage.removeItem('resource_userFullName');
  localStorage.removeItem('resource_userRoles');
  localStorage.removeItem('resource_orgRoles');
};

AppData.isLoggedIn = () => {
  if (localStorage.getItem('resource_authToken')) {
    setAppAuthData();

    return localStorage.getItem('resource_authToken').length > 0;
  }
  return false;
};

AppData.userID = () => {
  return +_systemData.userID;
};

AppData.userFullName = () => {
  return _systemData.userFullName;
};

AppData.userRoles = () => {
  return _systemData.userRoles;
};

AppData.organizationRoles = () => {
  return _systemData.organizationRoles;
};

AppData.timezone = () => {
  return _systemData.systemTimezone || 'UTC';
};

AppData.site_title = () => {
  return _systemData.site_title || 'HSC Bos';
};

AppData.logout = () => {
  if (AppData.isLoggedIn()) {
    fetch('/auth/logout').then(() => {
      _systemData.authToken = '';
      _systemData.userID = null;
      _systemData.userFullName = '';
      _systemData.userRoles = [];
      _systemData.organizationRoles = [];
      clearLocalStorageAuthData();
      AppData.notifyListeners('USER_LOGGED_OUT', false);
    });
  }
};

export default AppData;
